import { render, staticRenderFns } from "./TooltipPopup.vue?vue&type=template&id=70f4f960&"
import script from "./TooltipPopup.vue?vue&type=script&lang=js&"
export * from "./TooltipPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports